import React, {Component, useEffect, useRef, useState} from 'react'
import classnames from 'classnames'
import autobind from 'autobind-decorator'
import { isDescendant } from "../../utils/DomHelper"
import WindowEventHelper from "../../lib/WindowEventHelper";
import {connect, useSelector} from 'react-redux'
import { addPrefix } from "../../utils/UriUtil";
import {TISTORY} from "../../constants/Service"

function makeOldWriteUrl(type) {
  return addPrefix(`/manage/${type}`)
}

const POST = {name: 'post', label: '글'}
const NOTICE = {name: 'notice', label: '공지'}
const TEMPLATE = {name: 'template', label: '서식'}
const KEYWORD = {name: 'keyword', label: '키워드'}
const PAGE = {name: 'page', label: '페이지'}

function MenuItem({item}) {
  return (
    <li>
      <a href={makeOldWriteUrl(item.name)} className="link_list">
        {item.label}
      </a>
    </li>
  )
}

function WriteMenu({open, onClose}) {
  const useKeyword = useSelector(state => state.blog.activePlugins.indexOf('KeywordUI') >= 0)
  const isTistory = window.Config.service === TISTORY

  return (
    <div className={classnames({
      "wrap_menu": true,
      "hide": !open
    })}>
      <ul className="list_write">
        <MenuItem item={POST}/>
        {isTistory && <MenuItem item={NOTICE} />}
        <MenuItem item={TEMPLATE} />
        {useKeyword && <MenuItem item={KEYWORD} />}
        <MenuItem item={PAGE} />
      </ul>
      <a href="#" className="btn_close" onClick={onClose}>
        <span className="ico_blog ico_close">글 쓰기 메뉴 닫기</span>
      </a>
    </div>
  )
}



export default function WriteBox() {
  const [openSelect, setOpenSelect] = useState(false)
  const rootElm = useRef(null)

  function handleWindowClick(e) {
    let target = e.target

    if (!isDescendant(rootElm.current, target)) {
      handleCloseSelect()
    }
  }

  function handleOpenSelect(e) {
    e.preventDefault()
    setOpenSelect(true)
  }

  function handleCloseSelect(e) {
    if (e) {
      e.preventDefault()
    }
    setOpenSelect(false)
  }


  useEffect(() => {
    WindowEventHelper.add("click", handleWindowClick)

    return () => {
      WindowEventHelper.remove("click", handleWindowClick)
    }
  }, [])

  return (
    <div ref={rootElm} className="aside_write">
      <h3 className="screen_out">글 쓰기 바로가기</h3>
      <a href={makeOldWriteUrl('post')} className="link_write">쓰기</a>
      <a href="#" className="btn_open" onClick={handleOpenSelect}>
        <span className="txt_bar" />
        <span className="ico_blog ico_open">글 쓰기 메뉴 열기</span>
      </a>
      <WriteMenu open={openSelect} onClose={handleCloseSelect} />
    </div>
  )
}
